export const getDistanceToTopOfPage = element => {
  let distance = 0,
    currentElement = element

  while (currentElement) {
    distance += currentElement.offsetTop
    currentElement = currentElement.offsetParent
  }

  return distance
}
